import React                                                   from 'react';
import ReloadHelper                                            from '../../../utils/ReloadHelper';
import ActorLink                                               from './ActorLink';
import PriceLabel                                              from './PriceLabel';
import LikesCountLabel                                         from './LikesCountLabel';
import VipLabel                                                from './VipLabel';
import AgeLabel                                                from './AgeLabel';
import BoughtLabel                                             from './BoughtLabel';
import PropTypes                                               from 'prop-types';
import DiscountLabel                                           from "./DiscountLabel";
import Flux                                                    from "../../../flux/Flux";
import Translations                                            from "../../../utils/Translations";
import GuestAccess                                             from "../../../utils/GuestAccess";
import VXButton                                                from "../../SimpleElements/VXButton/VXButton";
import {COLOR_TYPE_CALL_TO_ACTION}                             from "../../SimpleElements/VXButton/ButtonHelper";
import {VXButtonConfig, VXButtonLineConfig, VXButtonLineStyle} from "../../SimpleElements/VXButton/VXButtonConfig";
import STYLES                                                  from "../../SimpleElements/VXButton/EnumVXButton";
import {getCurrencySymbol}                                     from '../../../utils/CommonUtils.js';

class AlbumItem extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			videoVoucherCount: Flux.Guest.getVoucherCountByType(Flux.Constants.VoucherTypes.TYPE_VIDEO, this.props.actor ? this.props.actor.actorId : null),
		};

		this.eventTracker = Flux.Tracker.getEventTracker();

		this.buyButton = null;

		this.trackClickEvent     = this.trackClickEvent.bind(this);
		this.getDefaultFooter    = this.getDefaultFooter.bind(this);
		this.getDurationElement  = this.getDurationElement.bind(this);
		this.getActorLinkElement = this.getActorLinkElement.bind(this);
		this.getSpecialFooter    = this.getSpecialFooter.bind(this);
		this.reloadVoucherCount  = this.reloadVoucherCount.bind(this);
		this.onClick             = this.onClickHandler.bind(this);
	}

	componentDidMount() {
		Flux.Guest.addGuestChangeListener(this.reloadVoucherCount);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.actor.actorId !== this.props.actor.actorId) {
			this.reloadVoucherCount();
		}
	}

	componentWillUnmount() {
		Flux.Guest.removeGuestChangeListener(this.reloadVoucherCount);
	}

	reloadVoucherCount() {
		this.setState({
			videoVoucherCount: Flux.Guest.getVoucherCountByType(Flux.Constants.VoucherTypes.TYPE_VIDEO, this.props.actor ? this.props.actor.actorId : null),
		});
	}

	onClickHandler(e) {
		if (Flux.Guest.isLoggedIn() && this.props.isVideoStation) {
			this.trackClickEvent();
		}

		return ReloadHelper.reload(this.props.url, e);
	}

	trackClickEvent() {
		const event = this.eventTracker.getNewEvent();

		event.type   = 'video_tile_click';
		event.source = 'www';

		event.context = this.props.isIndexPage ? 'video_station' : 'video_station_category';

		event.data = 'videoId=' + this.props.videoId + ';';
		event.data += 'url=' + window.location + ';';
		event.data += 'category=' + this.props.category + ';';

		this.eventTracker.trackEvent(event);
	}

	getDurationElement() {
		return this.props.duration
			? <small className="video-grid__item--duration">{this.props.duration} min</small>
			: null;
	}

	getActorLinkElement(specialTile = false) {
		return typeof this.props.actor !== 'undefined'
			? <ActorLink specialTile={specialTile} name={this.props.actor.name || 'deleted'} url={this.props.actor.url}/>
			: null;
	}

	getDefaultFooter() {
		const duration  = this.getDurationElement();
		const actorLink = this.getActorLinkElement();

		return (
			<footer className="video-grid__item--footer">
				<h5 className="video-grid__item--title-wrapper">
					<span className="video-grid__item--title" title={this.props.title}>{this.props.title}</span>
					{duration}
				</h5>
				{actorLink}
			</footer>
		);
	}

	getFormattedPrice(price) {
		let priceString = price.toFixed(2);
		priceString     = priceString.toString();

		priceString = priceString.replace('.', ',');

		return priceString + ' ' + getCurrencySymbol();
	}

	getSpecialFooter() {
		const duration  = this.getDurationElement();
		const actorLink = this.getActorLinkElement(true);

		const voucherPrice   = this.props.voucherPrice || 0;
		const voucherBalance = this.state.videoVoucherCount;
		const canVoucher     = voucherPrice && voucherBalance >= voucherPrice;

		const linkClick = (e) => {
			ReloadHelper.reload(this.props.url, e);
		};

		const onClick = (e) => {
			e.preventDefault();
			e.stopPropagation();

			GuestAccess.onEnoughMoneyForShop(
				this.props.actor.actorId,
				this.props.processedPrice,
				this.props.avs && !Flux.Guest.hasAvs(),
				this.props.isVip && !Flux.Guest.isVip(),
				() => {
					this.buyButton.startTransition();

					const clb = (actorId, changedAlbumId) => {
						if (changedAlbumId === this.props.videoId) {
							Flux.Gallery.removeGalleryChangeListener(clb);

							const config   = new VXButtonConfig();
							config.color   = COLOR_TYPE_CALL_TO_ACTION;
							config.line1   = [new VXButtonLineConfig('Video')];
							config.line2   = [new VXButtonLineConfig(Translations.get('WatchNow'))];
							config.icon    = 'vxbutton-icon-play-rounded-line';
							config.onClick = linkClick;

							this.buyButton.endTransition(config);
						}
					};

					Flux.Gallery.addGalleryChangeListener(clb);
					Flux.Gallery.buyAlbum(this.props.videoId);
				},
				undefined,
				canVoucher
			);
		};


		let button = null;
		if (this.props.price > 0) {
			if (canVoucher) {
				button = (
					<span className="video-grid__item--special-wrapper-right">
						<VXButton color={COLOR_TYPE_CALL_TO_ACTION}
						          line1={[new VXButtonLineConfig(Translations.get('Buy'), new VXButtonLineStyle([STYLES.UPPERCASE]))]}
						          line2={[new VXButtonLineConfig(voucherPrice + ' Voucher')]}
						          icon={"-icon-voucher-icon"}
						          onClick={onClick}
						          ref={ref => (this.buyButton = ref)}
						          animateSuccess={true}
						/>
					</span>
				);
			} else {
				let line2;
				if (this.props.discount) {
					line2 = [
						new VXButtonLineConfig(this.getFormattedPrice(this.props.price), new VXButtonLineStyle([STYLES.LINETHROUGH, STYLES.COLORS.MOOD3])),
						new VXButtonLineConfig(this.getFormattedPrice(this.props.processedPrice)),
					];
				} else {
					line2 = [new VXButtonLineConfig(this.getFormattedPrice(this.props.processedPrice))];
				}

				button = (
					<span className="video-grid__item--special-wrapper-right">
						<VXButton color={COLOR_TYPE_CALL_TO_ACTION}
						          line1={[new VXButtonLineConfig(Translations.get('Buy'), new VXButtonLineStyle([STYLES.UPPERCASE]))]}
						          line2={line2}
						          icon={"vxbutton-icon-cart-full"}
						          onClick={onClick}
						          ref={ref => (this.buyButton = ref)}
						          animateSuccess={true}
						/>
					</span>
				);
			}

		} else if (this.props.isBought) {
			button = (
				<span className="video-grid__item--special-wrapper-right">
					<VXButton color={COLOR_TYPE_CALL_TO_ACTION}
					          line1={[new VXButtonLineConfig(Translations.get('Video'), new VXButtonLineStyle([STYLES.UPPERCASE]))]}
					          line2={[new VXButtonLineConfig(Translations.get('WatchNow'))]}
					          icon={"vxbutton-icon-play-rounded-line"}
					          onClick={linkClick}
					          animateSuccess={true}
					/>
				</span>
			);
		} else {
			button = (
				<span className="video-grid__item--special-wrapper-right">
				      <VXButton
					      color={COLOR_TYPE_CALL_TO_ACTION}
					      line1={[new VXButtonLineConfig("Video"), new VXButtonLineStyle([STYLES.UPPERCASE])]}
					      line2={[new VXButtonLineConfig(Translations.get('BuyNow'))]}
					      icon={"vxbutton-icon-cart-full"}
					      onClick={onClick}
				      />
				</span>
			);
		}

		const title = this.props.title.length < 90 ? this.props.title : this.props.title.slice(0, 87) + '...';

		return (
			<footer className="video-grid__item--footer">
				<h5 className={"video-grid__item--special-wrapper-left" + (button === null ? ' -full-width' : '')}>
					<span className="video-grid__item--title" title={this.props.title}>{title}</span>
					<div className={"video-grid__item--special-wrapper-time"}>
						{duration}
						{actorLink}
					</div>
				</h5>
				{button}
			</footer>
		);
	}

	render() {
		const footer      = this.props.specialTile && !this.props.isMobile ? this.getSpecialFooter() : this.getDefaultFooter();
		const specialIcon = this.props.specialTile ?
			<img alt="Top Video" title="Top Video" className={"video-grid__item-special-icon"} src={"/assets/icons/top-trend-video-fire.svg"}/>
			: null;

		const backgroundStyle = {backgroundImage: "url('" + this.props.previewPicture + "')"};

		return (
			<div className={"video-grid__item" + (this.props.isMobile ? ' -mobile' : '')}
			     style={this.props.isMobile ? backgroundStyle : {}}
			     onClick={this.onClick}
			>
				<a href={this.props.url}
				   title={this.props.title}
				   style={this.props.isMobile ? {} : backgroundStyle}
				   className={"js-pjax-link" + (this.props.isMobile ? '' : ' video-grid__item-image')}
				   onClick={this.onClick}
				>
					{specialIcon}
					<div className={"video-grid__item--labels" + (this.props.specialTile ? ' -right' : '')}>
						{this.props.showPrice && this.props.discount > 0.0 ?
							<DiscountLabel discount={this.props.discount}
							               processedPrice={this.props.processedPrice}
							               price={this.props.price}
							               currency={this.props.currency}
							/> : null}
						{(this.props.showPrice && this.props.discount === 0.0) ?
							<PriceLabel currency={this.props.currency} price={this.props.processedPrice}/> : null}
						{this.props.showFsk ? <AgeLabel age={this.props.avs}/> : null}
						{this.props.showLikes && !this.props.isMobile
							? <LikesCountLabel likes={this.props.likesCount} short={this.props.likesShort}/>
							: null}
						{this.props.showPremium ? <VipLabel isVip={this.props.isVip}/> : null}
						{this.props.showBought && this.props.isBought ? <BoughtLabel/> : null}
					</div>
					<i className="icon -icon-play-rounded-line">&nbsp;</i>
				</a>
				{footer}
			</div>
		);
	}
}

AlbumItem.propTypes = {
	title:          PropTypes.string,
	price:          PropTypes.number,
	voucherPrice:   PropTypes.number,
	currency:       PropTypes.string,
	isPremium:      PropTypes.bool,
	isBought:       PropTypes.bool,
	duration:       PropTypes.string,
	likesCount:     PropTypes.number,
	likesShort:     PropTypes.string,
	avs:            PropTypes.number,
	isVip:          PropTypes.bool,
	url:            PropTypes.string,
	previewPicture: PropTypes.string,
	actor:          PropTypes.shape({
		actorId: PropTypes.number,
		name:    PropTypes.string,
		url:     PropTypes.string,
	}),
	showPrice:      PropTypes.bool,
	showLikes:      PropTypes.bool,
	showPremium:    PropTypes.bool,
	showBought:     PropTypes.bool,
	showFsk:        PropTypes.bool,
	showVip:        PropTypes.bool,
	isMobile:       PropTypes.bool,
	discount:       PropTypes.number,
	processedPrice: PropTypes.number,
	isIndexPage:    PropTypes.bool,
	videoId:        PropTypes.number,
	category:       PropTypes.string,
	isVideoStation: PropTypes.bool,
	specialTile:    PropTypes.bool,
};

AlbumItem.defaultProps = {
	showPrice:      false,
	showLikes:      false,
	showPremium:    false,
	showBought:     true,
	showFsk:        false,
	showVip:        false,
	duration:       null,
	isMobile:       false,
	discount:       0.0,
	processedPrice: 0.0,
	isVideoStation: true,
	specialTile:    false,
};

export default AlbumItem;
